import { createContext, FC, PropsWithChildren, useCallback, useState } from 'react';

import { Customer, Location, Redelivery } from 'types';

class GateRedeliveries {
  getEditable = (redeliveryNumber?: string, customer?: Customer, location?: Location): Redelivery | null => null;
  setEditable = (redelivery: Partial<Redelivery>): void => {};
  getGateRedelivery = (redeliveryNumber?: string, customer?: Customer, location?: Location): Redelivery | null => null;
  setGateRedelivery = (redelivery: Partial<Redelivery>): void => {};
  clearRedelivery = (redelivery: Redelivery): void => {};
}

export const GateRedeliveryContext = createContext(new GateRedeliveries());

export const GateRedeliveryProvider: FC<PropsWithChildren> = ({ children }) => {
  const [editables, setEditables] = useState<Map<string, Partial<Redelivery>>>(new Map());
  const [redeliveries, setRedeliveries] = useState<Map<string, Partial<Redelivery>>>(new Map());

  const getRedeliveryKey = useCallback((redelivery: Partial<Redelivery>) => {
    if (!redelivery.redeliveryNumber || !redelivery.customer || !redelivery.location) return null;
    else return `${redelivery.redeliveryNumber}-${redelivery.customer.id}-${redelivery.location.id}`;
  }, []);

  const getEditable = useCallback(
    (redeliveryNumber?: string, customer?: Customer, location?: Location) => {
      const redeliveryKey = getRedeliveryKey({ redeliveryNumber, customer, location });
      if (!redeliveryKey) return null;
      return editables.get(redeliveryKey) as Redelivery;
    },
    [getRedeliveryKey, editables]
  );

  const getGateRedelivery = useCallback(
    (redeliveryNumber?: string, customer?: Customer, location?: Location) => {
      const redeliveryKey = getRedeliveryKey({ redeliveryNumber, customer, location });
      if (!redeliveryKey) return null;
      return redeliveries.get(redeliveryKey) as Redelivery;
    },
    [getRedeliveryKey, redeliveries]
  );

  const setEditable = useCallback(
    (redelivery: Partial<Redelivery>) => {
      const redeliveryKey = getRedeliveryKey(redelivery);
      if (!redeliveryKey) return;
      setEditables(prevState => new Map(prevState).set(redeliveryKey, redelivery));
    },
    [getRedeliveryKey, setEditables]
  );

  const setGateRedelivery = useCallback(
    (redelivery: Partial<Redelivery>) => {
      const redeliveryKey = getRedeliveryKey(redelivery);
      if (!redeliveryKey) return;
      setRedeliveries(prevState => new Map(prevState).set(redeliveryKey, redelivery));
      setEditables(prevState => {
        const editablesCopy = new Map(prevState);
        editablesCopy.delete(redeliveryKey);
        return editablesCopy;
      });
    },
    [getRedeliveryKey, setEditables, setRedeliveries]
  );

  const clearRedelivery = useCallback(
    (redelivery: Redelivery) => {
      console.log(redelivery);
      setRedeliveries(prevState => {
        const newState = new Map(prevState);
        const key = getRedeliveryKey(redelivery);
        if (!!key) newState.delete(key);
        return newState;
      });
    },
    [getRedeliveryKey]
  );

  return (
    <GateRedeliveryContext.Provider
      value={{ getEditable, getGateRedelivery, setEditable, setGateRedelivery, clearRedelivery }}
    >
      {children}
    </GateRedeliveryContext.Provider>
  );
};
